import React, { useContext } from 'react';
import { UserContext } from '../../../context/UserInformation';
import { ProfileChatSection } from '../../../components/profile/ProfileChatSection';
import { useChatUser } from '../../../hooks/chat/useChatUser';
import { CHAT_CHANNEL_MEMBERS, CHAT_USERS_STATUS } from '../../../types/db/chat';
import { ChatService } from '../../../types/services/chat/ChatService';
import { rtdb } from '../../../services/firebase';
import { useNavigate } from 'react-router';
import { ROUTE_PATH } from '../../../utilities/navigation';
import { delay } from '../../../utilities';

interface IProfileChatContainerProps {
    userId: string;
}

export const ProfileChatContainer = ({ userId }: IProfileChatContainerProps) => {
    const navigate = useNavigate();
    const userContext = useContext(UserContext);
    const currentUserId = userContext?.user?.firebaseUser?.uid;
    const { user, isLoading, error } = useChatUser(userId);

    if (!currentUserId) {
        //cannot message someone if not connected
        return null;
    }

    if (currentUserId === userId) {
        //should not be able to chat with yourself
        return null;
    }

    if (isLoading) {
        return <ProfileChatSection loading />
    }

    if (!!error || !user) {
        return null;
    }

    const onSendMessage = async (message: string) => {
        const chatService = new ChatService(rtdb);
        return chatService
            .channels.create({
                type: 'direct',
                title: '',
                image: '',
                [CHAT_CHANNEL_MEMBERS]: {
                    [currentUserId]: { state: "joined" },
                    [userId]: { state: "joined" },
                },
            })
            .then(async (channelId) => {
                await chatService
                    .messages.create(channelId,
                        {
                            type: "text",
                            message,
                            sender: currentUserId,
                        }
                    )
                return channelId;
            })
            .then(async (channelId) => {
                await delay(2000);
                //navigate to the newly created conversation
                navigate(ROUTE_PATH.inboxBuild(channelId))
            })
    }

    return <ProfileChatSection
        user={{
            displayName: user.displayName,
            avatar: user.avatar,
            isOnline: user[CHAT_USERS_STATUS].state === 'online',
            lastOnline: new Date(+user[CHAT_USERS_STATUS].lastChanged)
        }}
        onMessageSentClick={onSendMessage}
    />;
}